import { Card } from "@amzn/stencil-react-components/card";
import { Col } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";
import type { PickupPhone } from "@/pages/Replacement/replacement.types";
import type { PickupBuilding } from "../choose-delivery.types";
import { BuildingSelect } from "./building-select";
import { PickupPhonePanel } from "./pickup-phone-panel";

export interface PickupPanelProps {
  buildings: PickupBuilding[];
  selectedBuilding?: PickupBuilding;
  onSelectBuilding: (building: PickupBuilding) => void;
  phone: PickupPhone;
  phoneCodes: string[];
  onChangePhone: (phone: PickupPhone) => void;
}

export const PickupPanel: FC<PickupPanelProps> = ({
  buildings,
  selectedBuilding,
  onSelectBuilding,
  phone,
  phoneCodes,
  onChangePhone,
}) => (
  <Card width="100%" data-testid="pickup-panel">
    <Col gridGap="S300" width="100%">
      <BuildingSelect
        buildings={buildings}
        selectedBuilding={selectedBuilding}
        onSelect={onSelectBuilding}
      />
      <PickupPhonePanel phone={phone} phoneCodes={phoneCodes} onChange={onChangePhone} />
    </Col>
  </Card>
);
